import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchResultsOverview } from '@uturn/portal/modules/search/pages/overview';
import z from 'zod';

export const SearchSearchSchema = z.object({
	q: z.coerce.string().optional(),
});

export const Route = createFileRoute('/_protected/search')({
	component: SearchResultsOverview,
	validateSearch: zodValidator(SearchSearchSchema),
});
